import React from 'react';
import PropTypes from 'prop-types';
import { Polygon as VisGlPolygon } from '@vis.gl/react-google-maps';

// @vis.gl/react-google-maps' Polygon takes google.maps.PolygonOptions as flat top-level props,
// but every call site in this app (carried over from @react-google-maps/api) passes them via
// an `options` object. This keeps those call sites unchanged.
const Polygon = React.forwardRef(({ options, ...props }, ref) => (
  <VisGlPolygon ref={ref} {...options} {...props} />
));

Polygon.displayName = 'Polygon';

Polygon.propTypes = {
  options: PropTypes.object
};

export default Polygon;
